import React from "react";
import BasePage from "../components/BasePage";

const MultiModalPage: React.FC = () => {
  return <BasePage title="多模态"></BasePage>;
};

export default MultiModalPage;
